import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ExhibitionClient } from '@Pass-It-Down/exhibition-client'

const url = process.env.REACT_APP_SERVER_URL
const api = new ExhibitionClient({url})


export const loadStories = createAsyncThunk('stories/loadStories', async (exhibitId) => {
  return api.story().getAllByExhibitId(exhibitId)
})

export const loadStory = createAsyncThunk('stories/loadStory', async (storyId) => {
  return api.story().getById(storyId)
})

export const loadNonFeaturedStories = createAsyncThunk('stories/loadNonFeaturedStories', async (exhibitId) => {
  const { getPageOfStories } = api.story().getPager({ exhibitId, limit: 2, featured: false})
  const stories = await getPageOfStories()

  const collectionIds = stories.map(s => s.collections[0])
  const collections = await Promise.all(collectionIds.map(id => api.collection().getById(id)))

  const names = collections.map(c => c.title)
  let i = 0
  stories.forEach(s => {
    s.collectionName = names[i]
    i++
  })

  return stories
})

export const storiesSlice = createSlice({
  name: 'stories',
  initialState: {
    story: { assets: []},
    stories: [],
    coverStory: {},
    chunkedStories: [],
    fullPageAdRefesh: 0,
    gameDayStoryId: ''
  },
  reducers: {
    clearStory: (state, _) => {
      state.story = { assets: [] }
    },
    fullPageAdRefresh: (state, _) => {
      state.fullPageAdRefesh =  state.fullPageAdRefesh + 1
    },
    setGameDayStoryId: (state, action) => {
      state.gameDayStoryId = action.payload
    }
  },
  extraReducers: {
    [loadStory.pending]: (state, _) => {
      state.story = { assets: [] }
    },
    [loadStory.fulfilled]: (state, action) => {
      const story = action.payload
      state.story = story
    },
    [loadStories.pending]: (_state, _action) => {
    },
    [loadStories.fulfilled]: (state, action) => {
      let newStories = api.util().dedupe([...state.stories, ...action.payload], '_id')
      newStories = api.rank().sort(newStories)
      state.stories = [...newStories]
      const [ first, ...restNewStories] = newStories
      state.coverStory = first
      state.chunkedStories = api.util().alternatingChunk(restNewStories, 3, 1)
    }
}})

export const clearStory = () =>  {
  return { type: 'stories/clearStory' }
}

export const refreshFullPageAd = () =>  {
  return { type: 'stories/fullPageAdRefresh' }
}


export const selectStories = state => state.stories.stories
export const selectChunkedStories = state => state.stories.chunkedStories
export const selectStory = state => state.stories.story
export const selectFullPageCoverStory = state => state.stories.coverStory
export const selectFullPageRefresh = state => state.stories.fullPageAdRefesh

export default storiesSlice.reducer
